import { useMutation } from "@tanstack/react-query";

import { axios, handleApiError } from "@features/config";

type AssignAIRequestType = {
  jobId: string;
  description?: string;
  model?: string;
};

export const assignJobAI = async ({ jobId, description, model }: AssignAIRequestType) => {
  try {
    const response = await axios.post(`/job/${jobId}/hired-ai`, {
      description,
      model,
    });
    return response?.data;
  } catch (error) {
    handleApiError(error);
  }
};

export const useAssignJobAI = () => {
  return useMutation(assignJobAI);
};
